// src/components/TablaNoFiscal.js
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from "./../services/http";
import { Typography, Table, Button, Input, Spin, Form, message, Popconfirm, Modal, DatePicker } from 'antd';

function TablaNoFiscal({ goBack }) {
  
  const location = useLocation();
  const { from } = location.state;
  const [obra, setObra] = useState();
  const navigate = useNavigate();
  const [montosNoFiscales, setMontosNoFiscales] = useState([]);
  const [loading, setLoading] = useState(true);
  const [messageApi, contextHolder] = message.useMessage();

  const [payments, setPayments] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY', 'DD-MM-YYYY', 'DD-MM-YY'];
  const [relacionAbono ,setRelacionAbono] = useState();
  const numberFormat = new Intl.NumberFormat('es-MX', {minimumFractionDigits: 2});

  const [form] = Form.useForm();
  const [data, setData] = useState(montosNoFiscales);
  const [editingKey, setEditingKey] = useState('');
  const isEditing = (record) => record.key === editingKey;
  const edit = (record) => {
    form.setFieldsValue({
      abono: (record.abono !== null && record.abono !== undefined ? record.abono : 0),
      ...record,
    });
    setEditingKey(record.key);
  };

  const fetchMontosNoFiscales = async () => {
    try {
      const response = await axios.HTTP_GET(`/api/relaciones/${from.id}`);
      const noFiscales = response.filter(relacion => relacion.tipo_monto === 'No Fiscal');
      for(let i = 0; i < noFiscales.lenght; i++) {
        if (noFiscales[i].abono === null || noFiscales[i].abono === undefined) noFiscales[i].abono = 0;
      }
      setMontosNoFiscales(noFiscales);
      setLoading(false);
    } catch (error) {
      console.error('Error al cargar los montos no fiscales:', error);
      setLoading(false);
    }
  };

  const fetchGetPayments = async () => {
    try {
      const response = await axios.HTTP_GET(`/api/v1/relationship/get-payments/${from.id}/No Fiscal`);
      const payments = response.filter(relacion => relacion.tipo_monto === 'No Fiscal');
      setPayments(payments);
    } catch (error) {
      console.error('Error al cargar los montos fiscales:', error);
      setLoading(false);
    }
  }

  useEffect(() => {
    setObra(from);
    fetchMontosNoFiscales();
    fetchGetPayments();
  }, [obra]);

  const agruparPorRelacion = (montos) => {
    const agrupados = {};
    montos.forEach(monto => {
      if (!agrupados[monto.numero_relacion]) {
        agrupados[monto.numero_relacion] = [];
      }
      agrupados[monto.numero_relacion].push(monto);
    });
    return agrupados;
  };

  const agruparAbonos = (abonos) => {
    const agrupados = {};
    abonos.forEach(abono => {
      if (!agrupados[abono.numero_relacion]) {
        agrupados[abono.numero_relacion] = [];
      }
      agrupados[abono.numero_relacion].push(abono);
    });
    return agrupados;
  };

  const calcularSubtotal = (montos) => {
    return montos.reduce((subtotal, monto) => subtotal + parseFloat(monto.importe || 0), 0).toFixed(2);
  };

  const montosAgrupados = agruparPorRelacion(montosNoFiscales);
  let abonosAgrupados = agruparAbonos(payments);

  const handleModal = async (record) => {
    setOpenDialog(true);
    setRelacionAbono(record);
  }

  const columns = [
    {
      title: 'Número de Relación',
      dataIndex: 'numero_relacion',
      key: 'numero_relacion',
    },
    {
      title: "Abono",
      dataIndex: 'abono',
      key: 'abono',
      width: '25%',
      editable: true,
    },
    {
      title: 'RETIRO',
      dataIndex: 'retiro',
      key: 'retiro',
    },
    {
      title: 'SALDO',
      dataIndex: 'saldo',
      key: 'saldo',
    },
    {
      title: 'Acciones',
      dataIndex: 'operation',
      render: (_, record) => {
        const editable = isEditing(record);
        return (
          <>
            <Typography.Link onClick={() => handleModal(record) }>
              Añadir abono
            </Typography.Link>
          </>
        );
      },
    },
  ];

  const UpdateRelationship = async () => {
    try {
      const values = await form.validateFields();
      console.log(relacionAbono)
      messageApi.open({ type: 'loading', content: 'Guardando control de pago....', duration: 0 });
      const response = await axios.HTTP_POST("/api/v1/relationship/add-payment", { importe: values.monto, obra_id: obra.id, numero_relacion: relacionAbono.numero_relacion, tipo_monto: "No Fiscal", fecha_abono: values.fecha_abono.$d, contratista_id: relacionAbono.contratista_id })
      if (response) {
        messageApi.destroy();
        message.success(response.data.msg);
        setEditingKey('');
        fetchMontosNoFiscales();
        fetchGetPayments();
        setOpenDialog(false);
        setRelacionAbono(null);
        form.resetFields();
      }

    } catch (e) {
      console.log("err**",e);
    }
  }

  const cancel = () => {
    setEditingKey('');
  };

  const Navigate = (path, params) => {
    navigate(path, params);
  }

  let dataSource = [];
  let accumulatedSaldo = 0;

  Object.keys(montosAgrupados).forEach((numeroRelacion) => {
    const montosRelacion = montosAgrupados[numeroRelacion];
    const subtotal = parseFloat(calcularSubtotal(montosRelacion));

    accumulatedSaldo += subtotal;

    dataSource.push({
      key: numeroRelacion,
      numero_relacion: numeroRelacion,
      retiro: subtotal.toFixed(2),
      abono: montosRelacion[0].abono,
      saldo: accumulatedSaldo.toFixed(2),
      contratista_id: montosAgrupados[numeroRelacion][0].contratista_id
    });
  });

  const restarSaldoConAbono = (abonos) => {
    let abonosTpm = {};
    
    Object.keys(abonos).forEach((numeroRelacion) => {
      let arrayAbonos = abonos[numeroRelacion];
      let relacion = dataSource.filter((item) => item.key === numeroRelacion);
      if (relacion && relacion.length > 0) { 
        let saldoAnterior = parseFloat(relacion[0].saldo);
      
        for(let i = 0; i < arrayAbonos.length; i++) {
          if (!abonosTpm[numeroRelacion]) {
            abonosTpm[numeroRelacion] = [];
          }
          arrayAbonos[i]["saldoAnterior"] = saldoAnterior;
          saldoAnterior = (saldoAnterior + arrayAbonos[i].importe) - parseFloat(relacion[0].retiro);
          arrayAbonos[i]["saldoRestante"] = saldoAnterior;

          abonosTpm[numeroRelacion].push(arrayAbonos[i]);
        }
      }
    });

    return abonosTpm;
  }

  abonosAgrupados = restarSaldoConAbono(abonosAgrupados);

  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }) => {
    const inputNode =  <Input />;
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{
              margin: 0,
            }}
            rules={[
              {
                required: true,
                message: `Ingresar ${title}!`,
              },
            ]}
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === 'abono' ? 'number' : 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  if (loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <Spin size="large" />
        <Typography>Cargando...</Typography>
      </div>
    );
  }

  return (
    <div style={{ marginTop: 32 }}>
      <Typography.Title level={5}>Tabla No Fiscal - {obra.nombre_obra}</Typography.Title>
      <Form form={form} component={false}>
        <Table
          components={{
            body: {
              cell: EditableCell,
            },
          }}
          dataSource={dataSource}
          columns={mergedColumns}
          rowClassName="editable-row"
          pagination={false}
          expandable={{
            expandedRowRender: (record) => (
              <>
                <Table
                  dataSource={abonosAgrupados[record.key] || []}
                  columns={[
                    { title: 'Fecha abono', dataIndex: 'f_abono', key: 'f_abono' },
                    { title: 'Abono', dataIndex: 'importe', key: 'importe', render: ((record) => {return `$ ${numberFormat.format(record)}` }) },
                    { title: 'Saldo', dataIndex: 'saldoRestante', key: 'saldoRestante', render: ((record) => {return `$ ${numberFormat.format(record)}` })  }
                  ]}
                  pagination={false}
                  rowKey={record => record.id}
                />
              </>
            ),
            rowExpandable: (record) => true, // Opcional: controla si una fila es expandible.
          }}
        />
      </Form>

      <Modal
        title="Añadir abono"
        open={openDialog}
        onCancel={() => setOpenDialog(false)}
        footer={[
          <Button key="cancel" onClick={() => setOpenDialog(false)}>
              Cancelar
          </Button>,
          <Button key="create" type="primary" htmlType="submit" onClick={UpdateRelationship}>
              Guardar
          </Button>,
        ]}
      >
        <Form layout="vertical" form={form}>
          <Form.Item
            label="Monto"
            name="monto"
            rules={[
              { required: true, message: 'Por favor ingrese el monto' },
            ]}
          >
            <Input type="number" min={0} placeholder="Ingrese el monto" />
          </Form.Item>
          <Form.Item label="Fecha del abono" name="fecha_abono" rules={[
              { required: true, message: 'Por favor ingrese la fecha' },
            ]}>
            <DatePicker style={{width:"100%"}} format={dateFormatList} locale={"es_mx"} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default TablaNoFiscal;
